// @ts-nocheck
import BaseFileManagement from "../../../app/commonComponents/fileManagementFields/baseFileManagement";
import ProcedureListService from "../../../service/procedureList";
import styles from "./index.module.scss";
import { Checkbox, Skeleton } from "antd";
import fileIcon from "../../../assets/image/fileIcon.svg";
import Buttons from "../../../base/basicComponents/button";
import NormalSpin from "../../../base/basicComponents/spin";
import NormalToolTip from "../../../base/basicComponents/toolTip";
import generateCoverSheet, {
  downloadPDF,
} from "app/commonComponents/fileManagementFields/coverSheet";
import { PreviewFileLink, CoverSheetPreviewType } from "app/pages/previewFile";

export default class ShareDocumentDownloadCheck extends BaseFileManagement {
  constructor(props: any) {
    super(props);
    this.state = {
      messageCode: null,
      procedureId: null,
      procedureTaskId: null,
      filesList: [],
      checkedFiles: [],
      isAllChecked: false,
      downloadNum: 0,
      allFilesNum: 0,
      loading: false,
    };
    // @ts-ignore
    this.shareId = this._getRoutingParam("ShareId");
  }

  handleCheckedAll = (e: any) => {
    if (e.target.checked) {
      this.setState({
        checkedFiles: [...this.state.filesList],
        isAllChecked: true,
      });
    } else {
      this.setState({
        checkedFiles: [],
        isAllChecked: false,
      });
    }
  };

  handleChecked = (e: any, file: any) => {
    let filesArr = [];
    if (e.target.checked) {
      filesArr = [...this.state.checkedFiles, file];
    } else {
      filesArr = this.state.checkedFiles.filter((item: any) => item.fileId !== file.fileId);
    }
    this.setState({
      checkedFiles: [...filesArr],
      isAllChecked: filesArr.length !== 0 && filesArr.length === this.state.filesList.length,
    });
  };

  isFileChecked = (id: any) => {
    const checkedFileIds = this.state.checkedFiles.map((item: any) => item?.fileId);
    return checkedFileIds.includes(id);
  };

  countDownloads = () => {
    this.setState({
      downloadNum: this.state.downloadNum + 1,
      loading: this.state.downloadNum + 1 !== this.state.allFilesNum,
    });
  };

  _downloadCheckSuccess = (result: any) => {
    const { messageCode, procedureId, procedureTaskId, shareFiles } = result;
    this.setState({
      messageCode,
      procedureId,
      procedureTaskId,
      filesList: shareFiles || [],
    });
    this._hideLoading();
  };

  /**
   * Check authority before downloading shared files
   */
  downloadCheck = () => {
    const Para = {
      // @ts-ignore
      shareId: this.shareId,
    };
    ProcedureListService.downloadCheck(Para, this._downloadCheckSuccess, (response: any) =>
      console.log(response)
    );
  };

  downloadSharedFiles = () => {
    this.setState({
      loading: true,
      downloadNum: 0,
      allFilesNum: this.state.checkedFiles.length,
    });
    let fileList: any[] = [];
    this.state.checkedFiles.forEach((file: any) => {
      if (file.fileId) {
        fileList.push({
          fileID: file.fileId,
          fileName: file.fileName,
        });
      } else {
        this.getCoverSheet();
      }
    });
    this.downloadFileByUrl(fileList, this.countDownloads);
  };

  getCoverSheetSuccess = async (result: any) => {
    const blob = await generateCoverSheet(result);
    downloadPDF(blob, "Cover Sheet.pdf");
    this.countDownloads();
  };

  getCoverSheet = () => {
    const getCoverSheetParam = {
      ProcedureId: this.state.procedureId,
      ProcedureTaskId: this.state.procedureTaskId,
    };
    ProcedureListService.getCoverSheet(
      getCoverSheetParam,
      this.getCoverSheetSuccess,
      (response: any) => console.log(response)
    );
  };

  getCoverSheetSuccessWithPreview = async (result: any) => {
    const blob = await generateCoverSheet(result);
    const blobUrl = URL.createObjectURL(blob);
    localStorage.setItem(
      "previewLink",
      JSON.stringify({ url: blobUrl, fileName: "Cover Sheet.pdf", type: CoverSheetPreviewType })
    );
    window.open("/PreviewFile", "_blank", "noopener,noreferrer");
    this._hideLoading();
  };

  getCoverSheetWithPreview = () => {
    const getCoverSheetParam = {
      ProcedureId: this.state.procedureId,
      ProcedureTaskId: this.state.procedureTaskId,
    };
    this._showLoading();
    ProcedureListService.getCoverSheet(
      getCoverSheetParam,
      this.getCoverSheetSuccessWithPreview,
      (response: any) => console.log(response)
    );
  };

  componentDidMount() {
    this._showLoading();
    this.downloadCheck();
  }

  render() {
    const {
      messageCode,
      filesList,
      isAllChecked,
      checkedFiles,
      loading,
      downloadNum,
      allFilesNum,
    } = this.state;

    return (
      <>
        {(messageCode === 26 || messageCode === 27) && (
          <div className={styles.messageWrapper}>
            <div className={styles.messages}>
              {messageCode === 26 && <div>You don't have permission to access these files.</div>}
              {messageCode === 27 && <div>The shared file is expired.</div>}
            </div>
          </div>
        )}
        {messageCode !== null &&
          messageCode !== undefined &&
          messageCode !== 26 &&
          messageCode !== 27 && (
            // @ts-ignore
            <NormalSpin
              spinning={loading}
              size="large"
              indicator={
                allFilesNum > 0 && (
                  <div className={styles.loadingText}>
                    Downloading {downloadNum < allFilesNum ? downloadNum + 1 : downloadNum}/
                    {allFilesNum} files
                  </div>
                )
              }
            >
              <div className={styles.shareDocument}>
                <div className={styles.title}>Download Files</div>
                <div className={styles.selectAllWrapper}>
                  <Checkbox
                    checked={isAllChecked}
                    onChange={(e) => this.handleCheckedAll(e)}
                    data-testid="share-doc-select-all-checkbox"
                  />
                  <span className={styles.selectAll}>Select All</span>
                </div>
                <div className={styles.documentListDiv}>
                  {filesList.length > 0 && (
                    <div>
                      {filesList.map((item: any, idx: any) => (
                        <div
                          className={styles.filesItem}
                          key={item.fileId}
                          data-testid={`share-doc-file-row-${item.fileId}`}
                        >
                          <Checkbox
                            checked={this.isFileChecked(item?.fileId)}
                            onChange={(e) => this.handleChecked(e, item)}
                            data-testid={`share-doc-file-checkbox-${item.fileId}`}
                          />
                          <img className={styles.icon} src={fileIcon} alt="Share File" />
                          <NormalToolTip
                            element={
                              <div className={styles.fileName}>
                                <PreviewFileLink
                                  fileId={idx === 0 ? CoverSheetPreviewType : item.fileId}
                                  fileName={item.fileName}
                                  onClick={(event) => {
                                    if (idx === 0) {
                                      event.preventDefault();
                                      this.getCoverSheetWithPreview();
                                    }
                                  }}
                                >
                                  {item.fileName}
                                </PreviewFileLink>
                              </div>
                            }
                            title={item.fileName}
                            placement="top"
                            color="#3E6CB5"
                            overlayClassName={styles.toolTip}
                            getPopupContainer={(triggerNode: any) => triggerNode.parentNode}
                          />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div className={styles.buttonDiv}>
                  <Buttons
                    color="blue"
                    size="middle"
                    disabled={checkedFiles.length === 0}
                    onClick={this.downloadSharedFiles}
                    testid="share-doc-download-btn"
                  >
                    Download
                  </Buttons>
                </div>
              </div>
            </NormalSpin>
          )}
        {(messageCode === null || messageCode === undefined) && (
          <div className={styles.messageWrapper}>
            <Skeleton active className={styles.skeleton} />
          </div>
        )}
      </>
    );
  }
}
